<template>
	<div>
		<div style="width: 100%;margin-bottom: 20px;">
			<el-breadcrumb separator-class="el-icon-arrow-right">
				<el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
				<el-breadcrumb-item>积分商品</el-breadcrumb-item>
			</el-breadcrumb>
		</div>

		<!-- 搜索筛选 -->
		<el-card class="box-card" style="margin-bottom: 20px;">
			<el-form :inline="true" class="user-search" :model="formInline">
				<el-form-item label="商品名称：">
					<el-input size="small" placeholder="请输入商品名称" v-model="formInline.goodsName" clearable></el-input>
				</el-form-item>
				<el-form-item label="订单编号：">
					<el-input size="small" placeholder="请输入订单编号" v-model="formInline.orderSn" clearable></el-input>
				</el-form-item>
				<el-form-item label="用户姓名：">
					<el-input size="small" placeholder="请输入用户姓名" v-model="formInline.name" clearable></el-input>
				</el-form-item>
				<el-form-item label="收货人手机号：">
					<el-input size="small" placeholder="请输入收货人手机号" v-model="formInline.phone" clearable></el-input>
				</el-form-item>
				<!-- <el-form-item label="订单状态">
					<el-select v-model="formInline.orderStatus" placeholder="请选择订单状态" clearable>
				
						<el-option label="待付款" value='nopay'></el-option>
						<el-option label="待发货" value='nosend'></el-option>
						<el-option label="待收货" value='norecevied'></el-option>
						<el-option label="已完成" value='finished'></el-option>
						<el-option label="已取消" value='cancel'></el-option>
						<el-option label="已关闭" value='close'></el-option>
					</el-select>
				</el-form-item> -->
				<el-form-item label="支付积分：">
					<el-input size="small" placeholder="最小值" v-model="formInline.payAmountMin" clearable style="width: 120px;"></el-input>
					<el-input size="small" placeholder="最大值" v-model="formInline.payAmountMax" clearable style="width: 120px;"></el-input>
				</el-form-item>
				<el-form-item label="兑换日期区间：">
					<datatime v-model="formInline.payTimeMin" catename="payTimeMin"></datatime>
					<datatime v-model="formInline.payTimeMax" catename="payTimeMax"></datatime>
				</el-form-item>
				<!-- <el-form-item label="奖品等级：">
					<el-select v-model="formInline.goodsLevel" placeholder="选择奖品等级" style="width: 150px;" clearable>
						<el-option :label="item" :value="item" v-for="item in 10" :key="item"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="奖品类别：">
					<el-select v-model="formInline.rankType" placeholder="选择奖品类别" style="width: 150px;" clearable>
						<el-option :label="item.name" :value="item.status" v-for="(item,index) in rankType"
							:key="index"></el-option>
					</el-select>
				</el-form-item> -->
				<el-form-item>
					<el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
				</el-form-item>
				<!-- <el-form-item>
					<el-button size="small" type="danger" icon="el-icon-plus" @click="handleadd">新增</el-button>
				</el-form-item> -->
			</el-form>
		</el-card>

		<!--列表-->
		<el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
			element-loading-text="拼命加载中" style="width: 100%;">
			<el-table-column sortable prop="orderId" label="更多信息" width="100" align="center" type="expand">
				<template slot-scope="scope">
					<el-row>
						<!-- <el-col :span="2">
							<div class="demo-detail">订单ID:{{scope.row.orderId }}</div>
						</el-col> -->
						<el-col :span="4">
							<div class="demo-detail">收货人姓名:{{scope.row.name }}</div>
						</el-col>
						<!-- <el-col :span="6">
							<div class="demo-detail">订单编号:{{scope.row.orderSn }}</div>
						</el-col> -->
						<el-col :span="6">
							<div class="demo-detail">手机号码:{{scope.row.phone }}</div>
						</el-col>
						<el-col :span="12">
							<div class="demo-detail">收货地址:{{scope.row.address }}</div>
						</el-col>
					</el-row>
				</template>
			</el-table-column>
			<el-table-column prop="goodsName" label="商品名称" align="center"> </el-table-column>
			<el-table-column prop="lastVersion" label="商品图片" align="center">
				<template slot-scope="scope">
					<el-image style="width: 60px;height: 60px;" :src="scope.row.img"
						:preview-src-list="[scope.row.img]">
					</el-image>
				</template>
			</el-table-column>
			<el-table-column prop="orderSn" label="订单编号" align="center">

			</el-table-column>
			<!-- <el-table-column prop="orderStatus" label="订单状态" align="center">
				<template slot-scope="scope">
					{{web.fomatOrderStatus(scope.row.orderStatus)}}
				</template>
			</el-table-column> -->
			<el-table-column prop="payAmount" label="支付积分" align="center">
			
			</el-table-column>
			<!-- <el-table-column prop="lastVersion" label="奖品类型" align="center">
				<template slot-scope="scope">
					{{scope.row.rankType == 'week'?'周':(scope.row.rankType == 'month'?'月':'年')}}
				</template>
			</el-table-column> -->
			<el-table-column prop="lastVersion" label="兑换时间" align="center">
				<template slot-scope="scope">
					{{web.formatTime(scope.row.payTime,'Y-M-D h:m')}}
				</template>
			</el-table-column>
			<el-table-column prop="remark" label="备注" align="center">
			
			</el-table-column>
			<el-table-column label="操作" align="center">
				<!-- <template slot-scope="scope">
					<el-button size="mini" @click="handleedit(scope.row)">
						编辑
					</el-button>
					<el-button size="mini" @click="handledelete(scope.row)">
						删除
					</el-button>
				</template> -->
			</el-table-column>
		</el-table>
		<!-- 分页组件 -->
		<Pagination :child-msg="pageparm" @callFather="callFather"></Pagination>
		


	</div>
</template>

<script>
	import {
		delPointsGoods,
		addPointsGoods,
		getAllPointsOrder
	} from '../../api/basisMG.js'
	// import uploadone from '@/components/uploadone'
	// 导出模块
	export default {
		components: {
			// uploadwgt,
		},

		// 模块数据
		data() {
			//数据  
			return {
				editorOption: {} ,
				editbj:{},
				rankType: [{
						name: '周',
						status: 'week'
					},
					{
						name: '月',
						status: 'month'
					},
					{
						name: '年',
						status: 'year'
					},
				],
				goodsImg: '',
				loading: true,
				visible: false,
				listData: [],
				dialogVisible: false,
				formInline: {
					start: 0,
					length: 10
				},
				editForm: {},
				// 分页参数
				pageparm: {
					currentPage: 1,
					pageSize: 10,
					total: 10,
					start: 0,
					length: 10
				},
			}
		},


		watch: {},

		methods: {
			handleUpload(url) {
				// this.editForm.wgtUrl = url
				this.$set(this.editForm, 'wgtUrl', url)
				console.log(this.editForm.wgtUrl)
			},
			handleUpload1(url) {
				this.$set(this.editForm, 'pkgUrl', url)
				// this.editForm.pkgUrl = url
				console.log(this.editForm.wgtUrl1)
			},
			handleadd() {
				this.dialogVisible = true
				this.editForm = {}

			},
			handleedit(row) {
				this.dialogVisible = true
				this.editForm = Object.assign({}, row)
			},
			handledelete(row) {
				this.$confirm('确认删除吗', '提示', {
					confirmButtonText: '确认',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					delPointsGoods({
						goodsId: row.goodsId
					}).then(res => {
						if (res.code == '200') {
							this.$message({
								message: '删除成功',
								type: 'success'
							})
							this.getdata()
						}

					})
				})

			},
			submitedit() {
				let param = this.editForm
				// param.upgradeId = this.editForm.id
				this.$confirm('确认提交吗', '提示', {
					confirmButtonText: '确认',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					addPointsGoods(param).then(res => {
						console.log(res)
						if (res.code == '200') {
							this.$message({
								message: '提交成功',
								type: 'success'
							})
							this.dialogVisible = false
							this.getdata()
						}

					})

				})

			},
			getdata() {
				getAllPointsOrder(this.formInline).then(res => {
					this.saveParams(this.$route.path,this.formInline)
					if (res.code == 200) {
						this.listData = res.data.content
						this.loading = false
						this.pageparm.total = res.data.totalElements
					}
				})
			},
			// 分页插件事件
			callFather(parm) {
				this.pageparm.currentPage = parm.currentPage
				this.pageparm.pageSize = parm.pageSize
				this.pageparm.start = parm.currentPage - 1
				this.pageparm.length = parm.pageSize
				this.formInline.start = parm.currentPage - 1
				this.formInline.length = parm.pageSize
				this.getdata(this.formInline)
			},
		},
		// 创建前状态(里面是操作)
		beforeCreate() {},
		// 创建完毕状态(里面是操作)
		created() {
			this.getParams(this.$route.path)
			this.getdata()
		},
		// 挂载前状态(里面是操作)
		beforeMount() {},
		// 挂载结束状态(里面是操作)
		mounted() {},
		// 更新前状态(里面是操作)
		beforeUpdate() {},
		// 更新完成状态(里面是操作)
		updated() {},
		// 销毁前状态(里面是操作)
		beforeDestroy() {},
		// 销毁完成状态(里面是操作)
		destroyed() {}
	};
</script>

<style scoped>

</style>
